var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "640.000000pt",
    height: "360.000000pt",
    viewBox: "0 0 640.000000 360.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,360.000000) scale(0.100000,-0.100000)",
    fill: "#4E4E4E",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2893 2278 l-22 -21 56 -61 c54 -58 55 -61 32 -64 -46 -6 -49 -20 -49 -268 0 -201 2 -235 16 -249 14 -14 50 -16 288 -14 l271 1 60 -67 60 -66 23 23 c12 14 22 28 22 32 0 15 -716 776 -730 776 -3 0 -15 -10 -27 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3210 2124 c0 -6 439 -474 446 -474 2 0 4 102 4 228 l-1 227 -79 -82 c-43 -46 -81 -83 -84 -83 -3 0 -6 37 -6 83 0 51 -5 88 -12 95 -12 12 -268 18 -268 6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamOffline);
export default __webpack_public_path__ + "static/media/stream_offline.b4c1c7213b2226bd49f33931da7d8665.svg";
export { ForwardRef as ReactComponent };